module.exports = __webpack_public_path__ + "static/trioimg4-e298c257e1f6ab1b572652cbb73114a1.jpg";